import classNames from 'classnames';
import React from 'react';
import { formatMoney } from '../../util/currency';
import { FormattedMessage } from '../../util/reactIntl';
import { discountCodeFromLineItemCode, isLineItemCustomerDiscount } from '../../util/types';
import { DiscountIcon } from './DiscountIcon/DiscountIcon';
import css from './OrderBreakdown.module.css';

const hasCustomerDiscount = lineItems => {
  return lineItems.find(item => isLineItemCustomerDiscount(item.code));
};

const LineItemCustomerDiscountMaybe = props => {
  const { lineItems, intl, code, transaction, currency } = props;

  if (!lineItems || !lineItems.length) {
    return null;
  }

  const baseLineItem = lineItems.find(item => item.code === code && !item.reversal);
  const customerDiscountLineItem = hasCustomerDiscount(lineItems);

  if (!customerDiscountLineItem) {
    return null;
  }

  const formattedDiscount = formatMoney(intl, customerDiscountLineItem.lineTotal);
  const discountPercentageAbsoluteString = customerDiscountLineItem?.percentage?.abs().toString();

  const formattedBasePrice = formatMoney(intl, baseLineItem.lineTotal);
  const discountCode = discountCodeFromLineItemCode(customerDiscountLineItem.code);

  // Build discount details from transaction.protectedData
  const protectedDiscount = transaction?.attributes?.protectedData?.discount;
  const isCapped = !!protectedDiscount?.isCapped;
  const discountDetails = protectedDiscount
    ? {
        isCapped,
        originalPercentage: protectedDiscount?.originalPercentage,
        percentage: protectedDiscount?.percentage,
        maxDiscount: protectedDiscount?.maxDiscount,
      }
    : null;

  const showDiscountIcon = discountDetails?.isCapped;

  return (
    <>
      <div className={css.lineItem}>
        <span className={css.itemLabel}>
          <FormattedMessage id="OrderBreakdown.basePrice" />
        </span>
        <span className={css.itemValue}>{formattedBasePrice}</span>
      </div>
      <div className={classNames(css.lineItem, css.lineItemWithDiscount)}>
        <span className={css.itemLabelWithIcon}>
          <FormattedMessage
            id="OrderBreakdown.customerDiscount"
            values={{ discountCode, isCapped, percentage: discountPercentageAbsoluteString }}
          />
          {showDiscountIcon ? (
            <DiscountIcon discount={discountDetails} currency={currency} intl={intl} />
          ) : null}
        </span>
        <span className={css.itemValue}>{formattedDiscount}</span>
      </div>
      <hr className={css.totalDivider} />
    </>
  );
};

export default LineItemCustomerDiscountMaybe;
